import {Header as HeaderType} from '@/(payload)/payload-types'
import Languages              from '@/app/(frontend)/[lang]/Languages'
import ThemeSelector          from '@/components/global/ThemeSelector'
import Clock_SVG              from '@/svg/Clock_SVG'
import cn                     from 'classnames'
import {useEffect, useState}  from 'react'
import styles                 from './LocalisationAndTime.module.scss'

type Props = {
	data: HeaderType, showContactLink?: boolean, hideOnMobile?: boolean,
}
const LocalisationAndTime = ({
	showContactLink = true,
	hideOnMobile = false,
	data,
}: Props) => {
	const dataThemes = {
		darkModeAriaLabel:  data?.darkModeAriaLabel || '',
		lightModeAriaLabel: data?.lightModeAriaLabel || '',
	}

	return (<div className={cn(styles['location-and-time'], {[styles['location-and-time--hiden-mobile']]: hideOnMobile})}>
		{/* Location and time */}
		<div className={styles['location-and-time__content']}>
			{/* Location */}
			<span className={styles['location']}>{data?.localization}</span>

			{/* Time */}
			<div className={styles['time']}>
				{/* Icon */}
				<Clock_SVG className={styles['time__icon']}/>

				{/* Value */}
				<Timer/>
			</div>
		</div>

		{/* Contact CTA */}
		{showContactLink && <a
			href={data?.link.url}
			className={styles['location-and-time__link']}
		>
			<span className={styles['location-and-time__contact']}>{data?.link.label}</span>
		</a>}

		{/* Theme */}
		<ThemeSelector dataThemes={dataThemes}/>
		<Languages/>
	</div>)
}

export default LocalisationAndTime

const getTime = () => new Date().toLocaleTimeString('fr-FR', {
	hour:   '2-digit',
	minute: '2-digit',
})

const Timer = () => {
	const [time, setTime] = useState<string | null>(null)

	useEffect(() => {
		setTime(getTime())
		const interval = setInterval(() => setTime(getTime()), 1000)
		return () => clearInterval(interval)
	}, [])

	return <span className={styles['time__value']}>{time ?? '--:--'}</span>
}
